import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getTopicPageData } from './api';
import type { TopicPageDataLoadError } from './types';

/** @knip-ignore */
export const {
	Context: TopicPageDataContext,
	Provider: TopicPageDataContextProvider,
	useContext: useTopicPageData,
	useAsyncData: useTopicPageDataFromApi,
	prefetchAsyncData: prefetchTopicPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'TopicPageDataContext',
	dataProperty: 'pageData',
	getData: getTopicPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler<TopicPageDataLoadError>(),
});
